<template>
   <div class="animated fadeIn" id="list-contacts">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-form v-on:submit.prevent="searchByFilters">
              <b-row>
                <b-col sm="4">
                  <b-form-group >
                    <label for="sujet"><strong>Sujet</strong></label>
                    <b-form-select v-model="sujet" :options="sujets"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group >
                    <label for="id_pp"><strong>N°Identifiant NSI</strong></label>
                    <b-form-input type="text" id="id_pp" v-model="idpp_criteria" :class="{hasError: errors.idpp_criteria !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.idpp_criteria }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group >
                    <label for="id_dossier"><strong>N° Dossier</strong></label>
                    <b-form-input type="text" id="id_dossier" v-model="dossier_criteria" :class="{hasError: errors.dossier_criteria !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.dossier_criteria }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group >
                    <label for="nir"><strong>N° Sécurité Sociale</strong></label>
                    <b-form-input type="text" id="nir" v-model="nir_criteria" :class="{hasError: errors.nir_criteria !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.nir_criteria }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group >
                    <label for="nom"><strong>Nom</strong></label>
                    <b-form-input type="text" id="nom" v-model="nom" :class="{hasError: errors.nom !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.nom }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group >
                    <label for="prenom"><strong>Prénom</strong></label>
                    <b-form-input type="text" id="prenom" v-model="prenom" :class="{hasError: errors.prenom !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.prenom }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click.prevent="searchByFilters" size="md" variant="primary">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des Contacts</strong>
      </b-card-header>
      <b-card-body>
        <contact-table :tableEntry="tableParam" ref="contact_table"></contact-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import ContactTable from '../../components/ContactTable'

export default {
  components: { ContactTable },
  data() {
    return {
      sujet: "",
      columns: ["created_at", "user.id_pp", "user.nir", "user.nom", "user.prenom", "sujet", "message"],
      items: [],
      sujets : [],
      idpp_criteria: '',
      dossier_criteria: '',
      nir_criteria: '',
      nom: '',
      prenom: '',
      noSearch: 'noSearch',
      options: {
        headings: {
          "created_at": "Date création",
          "user.id_pp" : "N° Ident. NSI",
          "user.nir": "N° Sécu. Soc.",
          "user.nom" : 'Nom',
          "user.prenom" : 'Prénom',
          sujet: "Sujet",
          message: "Message"
        },
        sortable: ["sujet"],
        filterable: ["sujet", "user.id_pp"],
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "N°Identifiant NSI, Sujet"
        }
      },
      user: [],
      sujet: 'Tous',

      errors: { idpp_criteria: '', nir_criteria: '', dossier_criteria: '', nom: '', prenom: ''}
    };
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl()
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken()
    this.$axios.defaults.headers.common["Accept"] = "application/json"
    this.$axios.defaults.headers.common["Provider"] = getProvider()

    if (this.$route.query.in) {
      this.idpp_criteria = this.$route.query.in
    }
    if (this.$route.query.do) {
      this.dossier_criteria = this.$route.query.do
    }
    if (this.$route.query.ns) {
      this.nir_criteria = this.$route.query.ns
    }
    if (this.$route.query.no) {
      this.nom = this.$route.query.no
    }
    if (this.$route.query.pr) {
      this.prenom = this.$route.query.pr
    }
    if (this.$route.query.su) {
      this.sujet = this.$route.query.su
    }
    // Si on à this.$route.query.su c'est qu'on revient d'une fiche et donc il y a eu une recherche , donc noSearch = ''
    if (this.$route.query.su) {
      this.noSearch = ''
    }

    this.allSubjects()
  },
  computed: {
    tableParam: {
      get() {
        let request = {};

        request.idpp_criteria = this.idpp_criteria.replace(/ /g, "")
        this.idpp_criteria = request.idpp_criteria
        request.dossier_criteria = this.dossier_criteria.replace(/ /g, "")
        this.dossier_criteria = request.dossier_criteria
        request.nir_criteria = this.nir_criteria.replace(/ /g, "")
        this.nir_criteria = request.nir_criteria
        request.sujet = this.sujet
        request.nom = this.nom
        request.prenom = this.prenom
        request.noSearch = this.noSearch
        
        return request;
      }
    },
  },
  methods: {
    allSubjects() {
      let self = this
      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/espaceBeneficiaire/admincontacts")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          let adminContacts = response.data.adminContacts

          for (let key in adminContacts){
            if (this.sujets.indexOf(adminContacts[key].sujet) < 0){
              this.sujets.push(adminContacts[key].sujet)
            }
          }
          this.sujets.sort();
          this.sujets.unshift('Tous');
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    formatNir(textNir) {
      if(textNir !== null  && textNir !== ''){
        if(textNir.length > 13){
          return textNir.substring(0,13)
        }
      }else{
        return textNir;
      }
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    showFiche(contactId) {
      this.$router.push({ path: '/espace-beneficiaire/gestion-des-contacts/' + contactId })
    },
    searchByFilters() {
      if (this.validateData()) {
        this.noSearch = ''
        this.$refs.contact_table.$refs.table.refresh()
      }
    },
    validateData() {
      this.clearErrors()
      let regNumeric = this.$store.getters.getRegNumeric
      let valid = true

      let idpp = this.idpp_criteria.replace(/ /g, "")
      if (idpp !== '') {
        if (!regNumeric.test(idpp)) {
          this.errors.idpp_criteria = 'Un N°Identifiant NSI ne doit contenir que des chiffres'
          valid = false
        }
        else if (idpp.length > 9 || idpp.length < 9) {
          this.errors.idpp_criteria = 'Un N°Identifiant NSI doit contenir exactement 9 chiffres'
          valid = false
        }
      }

      let num_dossier = this.dossier_criteria.replace(/ /g, "")
      if (num_dossier !== '') {
        if (!regNumeric.test(num_dossier)) {
          this.errors.dossier_criteria = 'Un N° Dossier ne doit contenir que des chiffres'
          valid = false
        }
      }
      
      let nir = this.nir_criteria.replace(/ /g, "")
      if (nir !== '') {
        if (!regNumeric.test(nir)) {
          this.errors.nir_criteria = 'Un N° de sécurité sociale ne doit contenir que des chiffres'
          valid = false
        }
        else if (nir.length > 13 || nir.length < 13) {
          this.errors.nir_criteria = 'Un N° de sécurité sociale doit contenir exactement 13 chiffres'
          valid = false
        }
      }
      return valid
    },
    clearErrors() {
      this.errors.idpp_criteria = ''
      this.errors.nir_criteria = ''
      this.errors.dossier_criteria = ''
      this.errors.nom = ''
      this.errors.prenom = ''
    },
    clearForm() {
      this.idpp_criteria = '' 
      this.nir_criteria = ''
      this.dossier_criteria = ''
      this.nom = ''
      this.prenom = ''
      this.sujet = 'Tous'
    }
  }
};
</script>

<style scoped>
.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
}
</style>

<style>
#list-contacts .VueTables__table thead tr th:first-child {
  width: 8%;
}
#list-contacts .VueTables__table thead tr th:nth-child(2) {
  width: 9%;
}
#list-contacts .VueTables__table thead tr th:nth-child(3) {
  width: 9%;
}
#list-contacts .VueTables__table thead tr th:nth-child(4) {
  width: 15%;
}
#list-contacts .VueTables__table thead tr th:nth-child(5) {
  width: 15%;
}
#list-contacts .VueTables__table thead tr th:nth-child(6) {
  width: 18%;
}
#list-contacts .VueTables__table thead tr th:nth-child(7) {
  width: 26%;
}
</style>
